import type React from 'react';
import { ClientsActionsModal } from '@pages/clients/actions-modal/ui';
import { AddClientsModal } from '@pages/clients/group-page/add-modal/ui';
import { ModalPayment } from '@features/events/event-visitor/modal-payment/ui';
import { useAppSelector } from '@shared/hooks';
import { Authentication } from 'modules';
import {
  ModalDialog,
  ModalDichotomous,
  ModalFrame,
  ModalInfo,
  ModalModeration,
  ModalOut,
  ModalRecommendetion,
  Popup,
} from 'library/components/common';
import {
  selectActionOpen,
  selectAddOpen,
  selectAuthOpen,
  selectDialogOpen,
  selectDichotomousOpen,
  selectFrameModal,
  selectIsPopupVisible,
  selectModerationOpen,
  selectNotifyOpen,
  selectOutOpen,
  selectPaymentOpen,
  selectRecommendOpen,
} from 'library/redux/modal';
import { AuthProvider } from '../Authentication/AuthContext';

const RootModal: React.FC = () => {
  const authOpen = useAppSelector(selectAuthOpen);
  const outOpen = useAppSelector(selectOutOpen);
  const notifyOpen = useAppSelector(selectNotifyOpen);
  const dialogOpen = useAppSelector(selectDialogOpen);
  const dichotomousOpen = useAppSelector(selectDichotomousOpen);
  const recommendOpen = useAppSelector(selectRecommendOpen);

  const moderationOpen = useAppSelector(selectModerationOpen);
  const popupVisible = useAppSelector(selectIsPopupVisible);
  const frameModal = useAppSelector(selectFrameModal);
  const paymentModal = useAppSelector(selectPaymentOpen);
  const actionOpen = useAppSelector(selectActionOpen);
  const addClientOpen = useAppSelector(selectAddOpen);

  return (
    <>
      {authOpen && (
        <AuthProvider>
          <Authentication />
        </AuthProvider>
      )}
      {outOpen && (
        <AuthProvider>
          <ModalOut />
        </AuthProvider>
      )}
      {dialogOpen && <ModalDialog />}
      {dichotomousOpen && <ModalDichotomous />}
      {notifyOpen && <ModalInfo />}
      {recommendOpen && <ModalRecommendetion />}
      {moderationOpen && <ModalModeration />}
      {popupVisible && <Popup />}

      {frameModal.isOpen && <ModalFrame />}
      {paymentModal && <ModalPayment />}
      {actionOpen && <ClientsActionsModal />}
      {addClientOpen && <AddClientsModal />}
    </>
  );
};

export default RootModal;
